// extracted by mini-css-extract-plugin
export default {"role-table__action":"Role_role-table__action__c7Dwu","role-table__action--button":"Role_role-table__action--button__CHzSu"};